import { PartialType } from '@nestjs/swagger';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { IsBoolean, IsOptional } from 'class-validator';
import { CreatePipelineDto } from './create-pipeline.dto';

export class UpdatePipelineDto extends PartialType(CreatePipelineDto) {
  @ApiPropertyOptional({ example: true, description: 'Baja lógica: el pipeline nunca se borra.' })
  @IsOptional()
  @IsBoolean()
  activo?: boolean;
}
